<template>
	<van-form ref="form">
		<slot></slot>
	</van-form>
</template>


<script>
import formValid from "@/components/tool/formValid";
export default {
  components: {},
  props: {
    label: {
      type: String,
      default: () => {
        return '';
      }
    },
    prop: {
      type: String,
      default: () => {
        return '';
      }
    },
    required: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      validater: null,
    }
  },
  created() {
		this.$nextTick(() => {
		  this.resetValidater();
		});
  },
	updated() {
		this.resetValidater();
	},
  methods: {
    resetValidater() {
			this.validater = formValid(this.$refs.form, this.formRule);
      // this.$nextTick(() => {
      //   this.validater = formValid(this.$refs.form, this.formRule);
      // });
    },
  }

}
</script>

<style lang="scss" scoped>
  .st-form-item {
    .st-van-filed-label.st-required {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }

    .st-err-msg {
      color: #ee0a24;
      font-size: 12px;
      padding: 4px 15px;
      font-weight: 400;
    }
    .err-show {
      display: block;
    }

    .err-hide {
      display: none;
    }

  }
  
	[disabled="disabled"] {
		pointer-events: none;
	}
</style>
